import { Context } from "./jobs-wrapper";
import { useState, useContext } from "react";
import {cleanJobTitle, buildJobURL, removeMainCat, formatDaysAgo, RemovePageQSFromURL, scrollToTopOfJobs, FixAnyOfTheseJobType, JobDetailPreview, RemoveAllSearchParamsFromURL} from '../helpers/helpers.js';
if (typeof window.theme_dir === 'undefined') window.theme_dir = "/wp-content/themes/jb-dhh";
if (typeof window.passive_url === 'undefined') window.passive_url = '/resumes/'

const JobResults = () => {
    const {data, loading, updateJobParams, pageIndex, updatePageIndex} = useContext(Context);
    //const [pageIndex, setPageIndex] = useState(1); //page click on or currently on

    const [paginationParamLoaded, setPaginationParamLoaded] = useState(false); //checks if page QS loads to ensure it only runs once and avoids a loop

    
    const resultsPerPage = 20;
    const dataIndex = Math.ceil(pageIndex / (1000/resultsPerPage )) //grouping of results i.e., first 1k=1, second 1k=2, etc up to 10 (10k results)
    const resultsOffsetFirst = pageIndex - ((dataIndex-1) * 50); //sets the offset num of results i.e., pageIndex3 - (dataIndex3-1) * 100
    const resultsOffset = (resultsOffsetFirst-1) * resultsPerPage // the final offset i.e., page 1 === (1-1) * 10 = 0, page 2 === (2-1) * 10 = 10, page 3 === (3-1) * 10 = 20, 
    const urlParams = new URLSearchParams(window.location.search);
    const paginationParam = (urlParams.get('pg')) ? parseInt(urlParams.get('pg')) : null;


    //console.log ("window.were_facets_used: " + window.were_facets_used);
    //console.log("dataIndex: " +dataIndex);
    //console.log("Da Data: " + JSON.stringify(data));
    //console.log("isLoading " + loading);

    const buildPagination = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);
        //console.log("buildPagination curr page: " + pageIndex);

       

        if (num_results > results_per_page){
            const curr_path = window.location.pathname;
            return (
                <nav aria-label="Job Listing Page Navigation">
                    <ul class="pagination">
                        {pageIndex !== 1 ? <li class="arrows"><a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} title="Previous Page" onClick={e => pageClick(e, (pageIndex-1))}><span>« Previous</span></a></li> : <li class="arrows disabled"><span><span aria-hidden="true">« Previous</span></span></li>}
                        <li>
                            <ul>
                            {
                            (() => {
                            
                                if (num_of_pages > 5) {

                                    return(
                                        <>
                                        {(pageIndex > 2) && <li><a href={curr_path} onClick={e => pageClick(e, 1)}>1</a></li>} {/*Add first page*/}
                                        {(pageIndex > 3) && <li class="disabled"><span><span aria-hidden="true">&hellip;</span></span></li>} {/*Add elipsis*/}

                                        {/*add "3 in a row"*/}
                                        {(pageIndex === num_of_pages) && <li><a href={curr_path+"?pg=" + (pageIndex- 2)} onClick={e => pageClick(e, (pageIndex-2))}>{pageIndex- 2}</a></li>} {/*add a -2 page if max page*/}
                                        {(pageIndex > 1) && <li><a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} onClick={e => pageClick(e, (pageIndex-1))}>{pageIndex- 1}</a></li>} {/*dont add -1 page if page 1*/}
                                        <li class="active disabled"><span>{pageIndex}</span></li>
                                        {(pageIndex < num_of_pages) && <li><a href={curr_path+"?pg=" + (pageIndex+ 1)} onClick={e => pageClick(e, (pageIndex+1))}>{pageIndex+ 1}</a></li>} {/*dont add a +1 if max page*/}
                                        {(pageIndex === 1) && <li><a href={curr_path+"?pg=" + (pageIndex + 2)} onClick={e => pageClick(e, (pageIndex+2))}>{pageIndex+ 2}</a></li>} {/*add a -2 page if page 1*/}

                                        {/*TEMP*/}
                                        {/*<li><a href="?pg=101" onClick={e => pageClick(e, 101)}>101</a></li>*/} 
                                        {/*<li><a href="?pg=999" onClick={e => pageClick(e, 999)}>999</a></li>*/} 
                                        {/*<li><a href="?pg=1001" onClick={e => pageClick(e, 1001)}>1001</a></li>*/} 
                                        {/*END TEMP*/}
                                    
                                        {
                                            pageIndex < (num_of_pages - 1) ? (
                                                <>
                                                {pageIndex < (num_of_pages - 2) && <li class="disabled"><span><span aria-hidden="true">&hellip;</span></span></li>}
                                                <li><a href={curr_path+"?pg=" + num_of_pages} onClick={e => pageClick(e, num_of_pages)}>{num_of_pages}</a></li>
                                                </>
                                            )
                                            :
                                            null
                                        }      
                                        </>
                                    )
                                }
                                else {
                                    let li_content = [];
                                    for (var i = 1; i <= num_of_pages; i++) {
                                        //console.log("i: " + i + ", pageIndex: " + pageIndex);
                                        const newI = i;
                                        if (i === pageIndex) {
                                            li_content.push(<li class="active disabled"><span>{pageIndex}</span></li>);
                                        } else {
                                            li_content.push(<li><a href={curr_path+"?pg=" + i} onClick={e => pageClick(e, newI)}>{i}</a></li>);
                                        }
                                    }
                                    //console.log("li_content: " + JSON.stringify(li_content));
                                    return li_content;
                                }
                            })()  
                            }
                            </ul>
                        </li>
                        {pageIndex < num_of_pages ? <li class="arrows"><a href={curr_path+"?pg=" + (pageIndex+1)} title="Next Page" onClick={e => pageClick(e, (pageIndex+1))}><span>Next »</span></a></li> : <li class="arrows disabled"><span><span aria-hidden="true">Next »</span></span></li>}
                    </ul>
                </nav>
            )
        }
        else {
            return (
                <div class="job_results__pagination"></div>
            )
        }
    }  

    const pageClick = (e, selectedPageNum) => {
        if (e !== null) {
            e.preventDefault()
            RemovePageQSFromURL()
        }

        
        let dataIndexOfClickedPage =  Math.ceil(selectedPageNum / (1000/resultsPerPage)) //to make dynamic, this should be Math.ceil(selectedPageNum / (1000/resultsPerPage))
        //console.log("dataIndexOfClickedPage: " + dataIndexOfClickedPage);
        //console.log("dataIndex: " + dataIndex);
        //console.log("selectedPageNum: " + selectedPageNum);

        //check if the dataIndex matches the new dataIndex so we know if we're over 1k results
        if (dataIndex !== dataIndexOfClickedPage) {

            // if we're in the first 10k
            if(dataIndexOfClickedPage <= 10) { /* the 10 = 10,000/1,000 */
                updateJobParams({"from" : (dataIndexOfClickedPage-1)*1000}) 
            }
            else {
                //if the user clicks on the "next page", we can just grab the sort_key and return results that way. 
                if(dataIndexOfClickedPage === (dataIndex+1) && Object.keys(data).length>0) {
                    let sort_id = data.hits.hits.at(-1).sort[0]
                    updateJobParams({"from" : 0, "sort_id" : sort_id})                    
                }
                else {
                    //calculate how many times we need the api to "search after 
                    let search_afters_needed = (dataIndexOfClickedPage - 10); //calculate how many times we need the api to "search after 
                    updateJobParams({"search_after_count" : search_afters_needed}) 
                }
                
            }
            
            //setDataIndex(dataIndexOfClickedPage)
            
        }
        
        updatePageIndex(selectedPageNum);
        scrollToTopOfJobs();
        setQueryStringParameter("pg", selectedPageNum);

    }

    const buildJobInfo = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);


        return (
            <div class="jobsFoundText col-xs-8 col-sm-12 text-left job-results-meta"><span>{num_results.toLocaleString("en-US")} {(parseInt(num_results) > 1) ? "Jobs" : "Job"} Found</span></div>
        )
    }

    const mobileMenuShow = () => {
        document.body.classList.add("mobile-facets-active");
        if (document.querySelector(".job-facets-column").classList.contains("show")) {
            document.querySelector(".job-facets-column").classList.remove("show");
            document.querySelector(".job-results-column").classList.remove("blurred");
        }
        else {
            document.querySelector(".job-facets-column").classList.add("show");
            document.querySelector(".job-results-column").classList.add("blurred");
        }
    }

    const setQueryStringParameter = (name, value) => {
        const params = new URLSearchParams(window.location.search);
        params.set(name, value);
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
    }


   
    if (typeof data.hits !== 'undefined') {
        if (paginationParam !== null && !isNaN(paginationParam) && paginationParamLoaded === false) {
            //logic for pg=x QS 
            setPaginationParamLoaded(true) //set to true so when this re-renders, it renders the HTML in the else if below
            pageClick(null, paginationParam) //set page 
        }
        else if((typeof data.hits !== 'undefined' && data.hits.total.value > 0 && paginationParam <= Math.ceil(data?.aggregations['job_count']["value"]/resultsPerPage))) {
            document.getElementById('job-detail') != null && (document.getElementById('job-detail').style.display = 'block') //show job detail
            return (
                
                <div class="job-results-column" aria-label="Listing of Available Jobs">
                    
                   
                    {/*console.log("new pageIndex: " + pageIndex)*/}
                    {/*!loading && console.log("total jobs count using facet: " + data.aggregations['job_count']["value"])*/}
                    {/*!loading && console.log(data.hits.hits)*/}
                    {<div class="job-results-meta"><span>{data.aggregations['job_count']["value"].toLocaleString("en-US")} {(parseInt(data.aggregations['job_count']["value"]) > 1) ? "Jobs" : "Job"} Found</span></div>}
                    {<button class="job-filter-show-mobile view-filters-toggle" aria-label="Show job filters" onClick={mobileMenuShow}>Filter</button>}
                    {
                        /** 
                        * to get right "offset" of pages, we need to (pageIndex-1 * resultsPerPage) so:
                        * page 1 will be (1-1) * 10 = offet 0 => pull results 0-9
                        * page 2 will be (2-1) * 10 = offet 10 => pull results 10-19
                        * page 3 will be (3-1) * 10 = offet 20 => pull results 20-29
                        **/
                    }
                    <ul class="job-list" aria-label="Listing of Available Jobs">
                        {data.hits.hits?.slice(resultsOffset).map((row, index) => (  
                            
                                index < resultsPerPage && ( // <= show only x items 

                                <li class="clickable job-card" data-job-link={buildJobURL(row.fields.job_title[0], row.fields.job_order_id[0], row.fields.job_category_id[0], row.fields.job_category[0], row.fields.job_city[0], row.fields.job_state_abbr[0], row.fields.job_postal[0])}>
                                    <div class="job-card__details">
                                        <h3><a class="job-card__title h3" href={buildJobURL(row.fields.job_title[0], row.fields.job_order_id[0], row.fields.job_category_id[0], row.fields.job_category[0], row.fields.job_city[0], row.fields.job_state_abbr[0], row.fields.job_postal[0])} title={cleanJobTitle(row.fields.job_title[0])} data-id={row.fields.job_order_id[0]}>{cleanJobTitle(row.fields.job_title[0])}</a></h3>
                                        <div class="job-card__location">{row.fields.job_city[0]}, {row.fields.job_state_abbr[0]}</div>
                                        <div class="job-card__excerpt">{JobDetailPreview(row.fields.job_description_raw[0])}</div>
                                    </div>
                                    <div class="job-card__meta">
                                        <span class="job-card__brand">{removeMainCat(row.fields.job_category[0])}</span>
                                        <span class="job-card__type">{(row.fields.job_type) && FixAnyOfTheseJobType(row.fields.job_type[0])}</span>
                                        <span class="job-card__date">{formatDaysAgo(row.fields.modified_at[0])}</span>
                                    </div>
                                </li>
                                
                                )
                        ))}
                    </ul>

                   
                    
                    {buildPagination(data.aggregations['job_count']["value"], resultsPerPage)}
                    {/*(!loading && !Object.keys(jobDetail).length>0) && console.log("JobDetails ON RENDER: " + JSON.stringify(jobDetail))*/}
                    {/*(paginationParam !== null || !isNaN(paginationParam)) && pageClick(null, paginationParam) /* check for page params */}

                    <div class="eeo-statement"><p><em>An Equal Opportunity Employer. All qualified applicants will receive consideration for employment without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, or protected veteran status and will not be discriminated against on the basis of disability.</em></p></div>
                   
                </div>
        
        
            )
        }
        else {
            return(

                <>
                    {RemoveAllSearchParamsFromURL()}
                    {window.kw_from_search = ""}
                   <div class="job-results-column">
                        <h3>No Jobs Found</h3>
                        <p>There are currently no jobs on this page or any that matched your search criteria.</p>
                        <p>Please try changing your search or <a href={window.passive_url} title="Send your resume">send your resume by completing our application here</a>.</p>
                    </div>

                    {(!window.were_facets_used) &&
                    <>
                        {window.predefined_kw = ""}
                        {window.predefined_job_types = ""}
                        {window.predefined_state = ""}
                        {window.predefined_city = ""}
                        {window.predefined_cats = ""}
                    </> 
                    }

                    {(document.querySelector(".job-results-column") !== null) && document.querySelector(".job-results-column").classList.remove("blurred")}
                </>
            )
        }
    } 
    else {
        return (

            <div class="jobs-are-loading">
                <div class="facets-jobs-loading">
                    <img alt="progress" src={window.theme_dir + "/images/jobs-loading.gif"} id="progress" />
                </div>
            </div>
        )
       
    }

}

export default JobResults;



